import React from 'react';
import PropTypes from 'prop-types';
import { IconContainer } from './style';
import Icon from '../Icon';

const MenuIcon = ({
  onClick,
  iconClass,
  notificationBadge = false,
  isActive,
}) => (
  <IconContainer onClick={onClick} isActive={isActive}>
    {notificationBadge && <span className="notification-badge" />}
    <Icon type={iconClass} />
  </IconContainer>
);

MenuIcon.propTypes = {
  onClick: PropTypes.func,
  notificationBadge: PropTypes.bool,
  iconClass: PropTypes.string,
  isActive: PropTypes.bool,
};

export default MenuIcon;
